import React, { useEffect, useMemo } from 'react'
import { useInstData, useEventHandler } from '../../public/hooks'
import { hasChangedValues, getFormValue, changeItemsValue, getMergedValues, getListItems, addListItem, deleteListItem } from '../../public/utility'
// import FlowRecordDetail from './FlowRecordDetail'
import FlowRecordFlowForm from './FlowRecordFlowForm'
import FlowRecordGridForm from './FlowRecordGridForm'
import FlowRecordMailList from './FlowRecordMailList'
import TreeSelect from '../../business/TreeSelect'

const FlowRecordDetail = props => {
	const { setState, me, me: {
		state: {
			components, subFlows, refreshing = true, id, processId, name, emailTemplet, actCdt, delCdt, type
		}
	} } = useInstData(props, useMemo(() => ({
		state: {
			id: props.id,
			type: props.type,
			processId: props.processId
		}
	}), []))

	const { onClose, onRefresh, mainFlowRecordId, onSubRecordFlowSaved, onSubRecordFlowDeleted, showBody: Body } = props

	const handleShowSubRecordFlow = useEventHandler(arg => {
		const { name, mainFlowRecordId, id, processId } = arg
		const { closeDialog } = Tyan.pubForm.showDialog('', FlowRecordDetail,
			{
				id, mainFlowRecordId, processId,
				onSubRecordFlowSaved: () => {
					//closeDialog && closeDialog()
					//onClose && onClose()
					handleRefresh()
				},
				onSubRecordFlowDeleted: () => {
					closeDialog && closeDialog()
					handleRefresh()
				}
			}, { height: '70%' }
		)
	})

	const handleShowDepSelectDiv = useEventHandler((title, onConfirm, onDelete) => {
		const { initValues, changedValues, optionsParas } = me.state
		const values = { ...initValues, ...changedValues, ...optionsParas }

		Tyan.pubForm.showDialog(title, props => <TreeSelect {...props} initValues={{ ...values.obj部门, treeName: values.treeName, treeField: values.treeField }} onConfirm={onConfirm} onDelete={onDelete} />)
	})

	const tryRefresh = () => {
		const { changedValues } = me.state
		const values = { ...changedValues }
		handleLoadForm(values)
	}

	const fieldset流转日志 = () => [{
		_html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' }
		// _grid: '', name: '流转日志', rowNumbers: true, /*  minRows: 3, maxRows: 10, */ height: '100%', minWidth: '95%',
		// columns: [
		// 	{ _text: '内容', name: '日志标题', flex: 4 },
		// 	{ _text: '审批意见', flex: 1 },
		// 	{ _text: '操作人', flex: 1 },
		// 	{ _date: '操作时间', flex: 1 },
		// ]
	}]

	const fieldset签核流程 = () => [{
		_html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' }
	},]

	const fieldset子流程 = (() => (subFlows && subFlows.map(subFlow => {
		if (!subFlow.disabled)
			subFlow.buttons = [{ _button: '添加 ...', handler: () => handleShowSubRecordFlow({ name: subFlow.name, processId: subFlow.processId, mainFlowRecordId: id, id: 0 }) }]
		subFlow.onDoubleTap = data => handleShowSubRecordFlow({ name: subFlow.name, processId: 0, mainFlowRecordId: id, id: data.id })
		return {
			title: subFlow.name, name: 'Others', _fieldset: [{ ...subFlow }], fullblock: true,
		}
	}) || []))()

	const fieldset = (() => {
		const loadComponent = ({ /* name,  */type, refresh, ...field }) => {
			const handlerDeleteList = (name, id) => {
				Tyan.pubForm.showConfirm('确定要删除？', () => deleteListItem(me, '', name, id))
			}

			const handlerAddList = (name) => {
				addListItem(me, {}, '', name)
			}
			const loadAddList = (field) => {
				const { list } = getListItems(me, '', field.name)
				const s = { margin: '0px 15px 5px 15px', minWidth: 80, flex: 10 }
				return {
					_border: field.name, minWidth: field.minWidth, hidden: false, margin: '0 0 0 18', padding: '5 10 0 0', disabled: field.disabled, items:
						[{
							_group: '', name: '标题', minWidth: '95%', items: field.items.map((o) => ({ _label: o.label, flex: 10 })).concat(
								{ _buttons: [{ _button: '添加', ui: '', handler: () => handlerAddList(field.name), cdt: () => !field.disabled },], width: '100' })
						}].concat(list && list.map((o) => {
							const _list = { listName: field.name, id: o.id }
							return {
								_group: '', name: o.id, minWidth: '95%', disabled: field.disabled,
								items: field.items.map((cmp) => ({ ...cmp, list: _list, ...s })).concat(
									{ _buttons: [{ _button: '删除', ui: '', handler: () => handlerDeleteList(field.name, o.id), disabled: field.disabled },], ...s, width: 100, flex: 1 })
							}
						}))
				}
			}

			const loadDepSelect = (field) => {
				return {
					_text: field._depselect, name: field.name + '_fullName', minWidth: '95%', disabled: true, required: true,
					button: {
						text: "...",
						handler: () => handleShowDepSelectDiv(
							field._depselect,
							(changedValues) => {
								changeItemsValue(me, '', [field.name + '_id', field.name, field.name + '_fullName'], [changedValues['id'], changedValues['名称'], changedValues['fullName']])
								field.onChange && field.onChange()
							},
						),
						hidden: field.disabled
					}
				}
			}

			const loadGrid = (field) => {
				return {
					...field,
					onDoubleTap: data => Tyan.pubForm.showDialog(field.name, FlowRecordGridForm, { flowRecordId: id, id: data.id, name: field.name })
				}
			}

			refresh && (field.onChange = tryRefresh)
			type == '_depselect' && (field = loadDepSelect(field))
			type == '_border' && field.items && (field.items = field.items.map(item => {
				return loadComponent(item)
			}))
			type == '_group' && (field = loadAddList(field))
			type == '_grid' && (field = loadGrid(field))
			return field
		}

		if (!components)
			return [{ _label: '装载中，请稍等...' }]
		return components.map(comp => loadComponent(comp))
	})()

	const handleLoadForm = (values = {}) => {
		const { id, processId } = me.state
		const stamp = me.refreshStamp = Date.now()
		Tyan.doPostEvent('GetFlowRecordForm', {
			// showFetchSpinner: false,
			data: { id, processId, changedValues: values },
			onEnd: ({ errorMessage, name, components, subFlows }) => {
				if (me.refreshStamp != stamp || me.unmounted) return
				if (errorMessage) {
					Ext.toast(`读取流程配置数据失败: ${errorMessage}`)
					onClose()
					return
				}
				setState({ components, subFlows, name })
				handleRefresh(values)
			}
		})
	}

	const handleRefresh = (values = {}, refreshEvent = false) => {
		const { id, processId } = me.state
		setState({ refreshing: true })
		const stamp = me.refreshStamp = Date.now()
		Tyan.doPostEvent('GetFlowRecord', {
			data: { id, processId, mainFlowRecordId, changedValues: values, refreshEvent },
			onEnd: ({ errorMessage, initValues, optionsParas, initValuesOthers, emailTemplet, actCdt, delCdt }) => {
				if (me.refreshStamp != stamp || me.unmounted) return
				if (errorMessage) {
					Ext.toast(`读取流程数据失败: ${errorMessage}`)
					return
				}
				setState({ initValues, optionsParas, changedValues: values, initValuesOthers, emailTemplet, refreshing: false, actCdt, delCdt })
			}
		})
	}

	const handleSave = () => {
		const { id, processId } = me.state
		const values = getMergedValues(me, '')
		Tyan.doPostEvent({
			event: 'SaveFlowRecord',
			data: { id, processId, mainFlowRecordId, changedValues: values },
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('保存成功')
					setState({ id, processId })
					handleRefresh()
					onSubRecordFlowSaved && onSubRecordFlowSaved()
					// onRefresh && onRefresh()
					// onClose && onClose()
				}
			}
		})
	}

	const handlerDelete = () => {
		const { id } = me.state
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteFlowRecord',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						if (onSubRecordFlowDeleted)
							onSubRecordFlowDeleted()
						else {
							onRefresh && onRefresh()
							onClose && onClose()
						}
					}
				}
			}))
	}

	const handlePrint = () => {
		const { id } = me.state
		Tyan.pubForm.showExport({ event: 'PrintFlowRecord', eventData: { id } })
	}

	// const _bEdit = (o) => {
	// 	if (o._border)
	// 		return o.items && o.items.filter(item => _bEdit(item)).length > 0
	// 	else
	// 		return !o.disabled
	// }
	const bEdit = () => {
		return fieldset.filter(o => !o.disabled).length > 0
	}

	const handlerClose = () => {
		onClose()
	}
	const bChanged = () => {
		return hasChangedValues(me)
	}

	const bSave = () => {
		const { changedValues } = me.state
		return changedValues && Object.keys(changedValues).length > 0
	}

	const _haveRequired = (o, values) => {
		if (o._border && !o.disabled)
			return o.items && o.items.filter(item => _haveRequired(item, values)).length > 0
		else
			return o.required && ((!o._files && (Object.keys(values).indexOf(o.name) == -1 || values[o.name] == null)) ||
				(o._files && (!getFormValue(me, '', o.name) || getFormValue(me, '', o.name).length == 0)))
	}

	const haveRequired = () => {
		const { initValues, changedValues } = me.state
		const values = { ...initValues, ...changedValues }
		return fieldset.filter(o => _haveRequired(o, values)).length > 0
	}

	useEffect(() => {
		handleLoadForm()
	}, [])

	const fieldsets = (() => [{
		title: name, name: '', _fieldset: fieldset, disabled: refreshing,
	}])()

	const _fieldsets = (() => [
		{ title: '签核流程', name: 'Others', _fieldset: fieldset签核流程(), fullblock: true },
		{ title: '流转日志', name: 'Others', _fieldset: fieldset流转日志(), fullblock: true },
		...fieldset子流程])()

	return <Body data={me} maxWidth="100%"
		controls={
			[
				{ _recordflow: 'RecordFlow', disabled: bSave() || haveRequired(), recordFlowForm: FlowRecordFlowForm, cdt: () => actCdt },
				{ _button: '保存', icon: 'save', handler: handleSave, disabled: !bSave() || haveRequired(), cdt: () => !refreshing && bEdit() && type != 'show' },
				{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && !refreshing && delCdt && type != 'show', handler: handlerDelete },
				{ _button: '邮件', icon: 'envelope-o', cdt: () => emailTemplet && emailTemplet != '', handler: () => Tyan.pubForm.showDialog('邮件列表', FlowRecordMailList, { flowRecordId: id, emailTemplet }) },
				{ _button: '打印', icon: 'print', handler: handlePrint, cdt: () => id > 0 },
				{ _button: bChanged() && '取消' || '关闭', icon: 'close', handler: handlerClose },
			]
		}
		fieldsets={
			[

				...fieldsets,
				{ _fieldsets, docked: 'right', width: '45%', },

			]
		}
	/>
}

export default FlowRecordDetail